// extracted by mini-css-extract-plugin
module.exports = {"container":"Sl-z","disabled":"Tl-z","remove":"Ul-z"};